import { moveDynamicFieldsToCustomFields } from './segmentInteractionCustomFields';
import { useRealtimeDbProviderName } from './useRealtimeDbProviderName';

export const useTransformRealtimeDbProps = () => {
  const dataProviderName = useRealtimeDbProviderName();
  const isSupabaseProvider = dataProviderName === 'supabase';
  /**
   * Transforms realtime DB props based on app region.
   * @param props.supabaseFilters - Filters specific to Supabase (China region)
   * @param props.firestoreFilters - Filters specific to Firestore (global region)
   * @param props.filters - Common filters applied to both providers
   * @param props.realtimeFilters - Realtime filters for Firestore
   * @param props.supabaseRealtimeFilters - Realtime filters for Supabase
   */
  const transformRealtimeDBProps = (props: any) => {
    const {
      resource,
      resourcePath = '',
      supabaseFilters = [],
      firestoreFilters = [],
      filters = [],
      realtimeFilters = [],
      supabaseRealtimeFilters = [],
      ...restProps
    } = props || {};
    // For China region, transform the resource query to use filters instead of direct ID lookup
    const baseProps = isSupabaseProvider
      ? {
          ...restProps,
          resource,
          resourcePath,
          filters: [...supabaseFilters, ...filters],
          realtimeFilters: supabaseRealtimeFilters,
        }
      : {
          ...restProps,
          resource: resource ? `${resourcePath}${resource}` : '',
          resourcePath,
          filters: [...firestoreFilters, ...filters],
        };

    if (resource !== 'user_segment_interactions' || !restProps.data) {
      return baseProps;
    }

    // user_segment_interactions: dynamic fields live in custom_fields; Supabase upserts on segment_interaction_id.
    return {
      ...baseProps,
      data: moveDynamicFieldsToCustomFields(restProps.data),
      ...(isSupabaseProvider && {
        options: { ...restProps.options, conflictTarget: 'segment_interaction_id' },
      }),
    };
  };

  return transformRealtimeDBProps;
};
